import React from 'react';
import { LucideIcon } from 'lucide-react';

interface WidgetProps {
  icon: LucideIcon;
  title: string;
  children: React.ReactNode;
  className?: string;
}

const Widget: React.FC<WidgetProps> = ({ icon: Icon, title, children, className = '' }) => {
  return (
    <div className={`glass-card-strong rounded-xl border border-black/[0.08] overflow-hidden ${className}`}>
      <div className="px-5 py-4 border-b border-black/[0.06] flex items-center gap-3">
        <Icon className="w-5 h-5 text-[#64748b]" />
        <h3 className="text-[#0f172a] font-semibold">{title}</h3>
      </div>
      <div className="p-5">{children}</div>
    </div>
  );
};

export default Widget;
